(function () {
  'use strict';

  /* アクティブサムネイルを中央に配置（SP:左から3番目、PC:左から4番目） */
  function scrollToActiveThumb(gallery, activeThumb) {
    var container = gallery.querySelector('.kido-gallery__thumbs');
    if (!container) return;
    var thumbEls = Array.prototype.slice.call(gallery.querySelectorAll('.js-kido-thumb'));
    var idx = thumbEls.indexOf(activeThumb);
    var isMobile = window.matchMedia('(max-width: 767px)').matches;
    var offset = isMobile ? 2 : 3;
    var anchorIdx = Math.max(0, idx - offset);
    if (anchorIdx === 0) {
      container.scrollTo({ left: 0, behavior: 'smooth' });
      return;
    }
    var anchorThumb = thumbEls[anchorIdx];
    var containerRect = container.getBoundingClientRect();
    var anchorRect = anchorThumb.getBoundingClientRect();
    var paddingLeft = parseFloat(window.getComputedStyle(container).paddingLeft) || 0;
    var newScrollLeft = container.scrollLeft + anchorRect.left - containerRect.left - paddingLeft;
    container.scrollTo({ left: Math.max(0, newScrollLeft), behavior: 'smooth' });
  }

  /* サムネイルクリック */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest ? e.target.closest('.js-kido-thumb') : null;
    if (!thumb) {
      var el = e.target;
      while (el && el !== document) {
        if (el.classList && el.classList.contains('js-kido-thumb')) { thumb = el; break; }
        el = el.parentNode;
      }
    }
    if (!thumb) return;

    var gallery = thumb.closest ? thumb.closest('.kido-gallery') : thumb.parentNode.parentNode.parentNode.parentNode;
    if (!gallery) return;

    var thumbEls = Array.prototype.slice.call(gallery.querySelectorAll('.js-kido-thumb'));
    var mainImg  = gallery.querySelector('.js-kido-main-img');
    var zoomWrap = gallery.querySelector('.js-kido-zoom-container');
    var idx = thumbEls.indexOf(thumb);
    if (idx < 0 || !mainImg) return;

    thumbEls.forEach(function (t, i) {
      t.classList[i === idx ? 'add' : 'remove']('is-active');
    });

    scrollToActiveThumb(gallery, thumb);

    var pane = gallery.querySelector('.js-kido-pane');
    var lens = gallery.querySelector('.js-kido-lens');
    if (pane) pane.style.display = 'none';
    if (lens) lens.style.display = 'none';

    var FADE_MS    = 300;
    var newSrc     = thumb.dataset.src;
    var newAlt     = thumb.dataset.alt || '';
    var newZoomSrc = thumb.dataset.zoomSrc;

    mainImg.style.opacity = '0';

    var preload = new Image();
    preload.src = newSrc;

    setTimeout(function () {
      mainImg.src = newSrc;
      mainImg.alt = newAlt;
      if (zoomWrap) zoomWrap.dataset.zoomSrc = newZoomSrc;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          mainImg.style.opacity = '1';
        });
      });
    }, FADE_MS);
  });

  /* 前後ボタン */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.js-kido-prev, .js-kido-next') : null;
    if (!btn) return;
    var gallery  = btn.closest('.kido-gallery');
    if (!gallery) return;
    var thumbEls = Array.prototype.slice.call(gallery.querySelectorAll('.js-kido-thumb'));
    var active   = gallery.querySelector('.js-kido-thumb.is-active');
    var cur      = active ? thumbEls.indexOf(active) : 0;
    var next     = btn.classList.contains('js-kido-prev')
      ? (cur - 1 + thumbEls.length) % thumbEls.length
      : (cur + 1) % thumbEls.length;
    thumbEls[next].click();
  });

  /* スマホ：スワイプで前後移動 */
  var _swipeTouchStartX = 0;
  var _swipeTouchStartY = 0;
  var _swipeGallery = null;

  document.addEventListener('touchstart', function (e) {
    var wrap = e.target.closest ? e.target.closest('.kido-gallery__main-wrap') : null;
    if (!wrap) return;
    _swipeGallery = wrap.closest('.kido-gallery');
    _swipeTouchStartX = e.touches[0].clientX;
    _swipeTouchStartY = e.touches[0].clientY;
  }, { passive: true });

  document.addEventListener('touchend', function (e) {
    var gallery = _swipeGallery;
    _swipeGallery = null;
    if (!gallery) return;
    var dx = e.changedTouches[0].clientX - _swipeTouchStartX;
    var dy = e.changedTouches[0].clientY - _swipeTouchStartY;
    if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
    var thumbEls = Array.prototype.slice.call(gallery.querySelectorAll('.js-kido-thumb'));
    if (thumbEls.length < 2) return;
    var active = gallery.querySelector('.js-kido-thumb.is-active');
    var cur = active ? thumbEls.indexOf(active) : 0;
    var next = dx < 0
      ? (cur + 1) % thumbEls.length
      : (cur - 1 + thumbEls.length) % thumbEls.length;
    thumbEls[next].click();
  }, { passive: true });

  /* ホバーズーム（PCのみ・キャプチャフェーズ） */
  document.addEventListener('mouseenter', function (e) {
    if (window.matchMedia('(max-width:767px)').matches) return;
    var wrap = e.target.closest ? e.target.closest('.js-kido-zoom-container') : null;
    if (!wrap) return;
    var gallery = wrap.closest('.kido-gallery');
    var pane    = gallery && gallery.querySelector('.js-kido-pane');
    var lens    = gallery && gallery.querySelector('.js-kido-lens');
    var paneImg = gallery && gallery.querySelector('.js-kido-pane-img');
    if (!pane || !lens || !paneImg) return;
    var src = wrap.dataset.zoomSrc;
    if (!src) return;
    if (paneImg.getAttribute('src') !== src) paneImg.src = src;
    var ZOOM = 2.5;
    var w = wrap.offsetWidth;
    var h = wrap.offsetHeight;
    pane.style.width   = w + 'px';
    pane.style.height  = h + 'px';
    paneImg.style.width  = (w * ZOOM) + 'px';
    paneImg.style.height = (h * ZOOM) + 'px';
    pane.style.display = 'block';
    lens.style.display = 'block';
  }, true);

  document.addEventListener('mouseleave', function (e) {
    var wrap = e.target.closest ? e.target.closest('.js-kido-zoom-container') : null;
    if (!wrap) return;
    /* コンテナ内の子要素間の移動では非表示にしない */
    if (e.relatedTarget && wrap.contains(e.relatedTarget)) return;
    var gallery = wrap.closest('.kido-gallery');
    var pane = gallery && gallery.querySelector('.js-kido-pane');
    var lens = gallery && gallery.querySelector('.js-kido-lens');
    if (pane) pane.style.display = 'none';
    if (lens) lens.style.display = 'none';
  }, true);

  document.addEventListener('mousemove', function (e) {
    if (window.matchMedia('(max-width:767px)').matches) return;
    var wrap = e.target.closest ? e.target.closest('.js-kido-zoom-container') : null;
    if (!wrap) return;
    var gallery = wrap.closest('.kido-gallery');
    var lens    = gallery && gallery.querySelector('.js-kido-lens');
    var pane    = gallery && gallery.querySelector('.js-kido-pane');
    var paneImg = gallery && gallery.querySelector('.js-kido-pane-img');
    if (!lens || !pane || !paneImg) return;
    var rect = wrap.getBoundingClientRect();
    var x  = e.clientX - rect.left;
    var y  = e.clientY - rect.top;
    var w  = rect.width;
    var h  = rect.height;
    var ZOOM = 2.5;
    var lw = w / ZOOM;
    var lh = h / ZOOM;
    var lx = Math.max(0, Math.min(x - lw / 2, w - lw));
    var ly = Math.max(0, Math.min(y - lh / 2, h - lh));
    lens.style.width   = lw + 'px';
    lens.style.height  = lh + 'px';
    lens.style.left    = lx + 'px';
    lens.style.top     = ly + 'px';
    paneImg.style.transform =
      'translate(' + (-(lx / w) * pane.offsetWidth  * ZOOM) + 'px,' +
                     (-(ly / h) * pane.offsetHeight * ZOOM) + 'px)';
  });
})();
